const accessPay = {
  path: 'accessPay',
  component: resolve => require(['../../../../../../pages/admin/reviewed/alipay/accessPay'], resolve),
  meta: {isAccessPay: true}
}

export default accessPay
